<div class="loading" *ngIf="isAuthenticated">
    <div style="text-align: center;" *ngIf="!isDoneLoading">Authentification...</div>
    <div style="text-align: center;" *ngIf="isDoneLoading && !userProfileLoaded">Chargement de votre profil...</div>
</div>
<div class="bg" *ngIf="!isAuthenticated">
    <div class="title">
        <svg class="logo" aria-hidden="true">
          <use href="#logo" xlink:href="#logo">
            <svg id="logo" viewBox="0 0 283.47 283.46"><path d="M27.1 203.62H64a4.78 4.78 0 004-2.48l56.31-121-19.87-42.75zM170.78 19.7C162.21.49 139.81 0 137.9 0h-16.07l93.59 201.13a4.81 4.81 0 004.06 2.49h36.88zm-60.42 211.16H78V239h11.9v44.47h8.61V239h11.89zm-47.19 0h-8.61v52.6H78.4v-8.14H63.17zm115 30.39a14.79 14.79 0 0011.23-14.86 15.05 15.05 0 00-6.4-12.45c-3.35-2.23-7.2-3.08-13.89-3.08h-9.57v52.6h8.62v-21.23h.84l14.77 21.23h10.53l-.44-.6zm-10-6.61V239h2.43c7 .06 10.4 2.59 10.43 7.56 0 5.29-3.59 8-10.75 8.09zm91.67-23.78h-3.46l-.11.21-24.38 52.39h9.23l5.82-12.6h21.67l5.45 12.6h9.38zm-9.28 31.87l7.4-16.27 7.13 16.27zm-120.18-31.87l-.09.21-24.4 52.39h9.25l5.81-12.6h21.69l5.43 12.6h9.38l-23.59-52.6zm-5.81 31.87l7.43-16.27 7.12 16.27zm73.82 20.73h29.35v-8.14H207v-16.5h20.13v-8.14H207V239h20.74v-8.13h-29.35zm-173.9-52.6l-.1.21L0 283.46h9.23l5.84-12.6h21.66l5.45 12.6h9.38L28 230.86zm-5.81 31.87l7.41-16.27 7.13 16.27z"></path></svg>
          </use>
      </svg>
      </div>
      <div class="card text-center" >
        <div class="card-header">
          <h3>
            Connexion à l'application eFac
          </h3>
        </div>
        <div class="card-body">
          <br>
          <button class="btn btn-primary" (click)="login()">
            Utiliser votre compte professionnel
          </button>
          <br><br>
        </div>
      </div>
</div>